module.exports = __webpack_public_path__ + "static/media/jeweler.74095a11.jpg";